const isPostcodeFrom = {
  berlin: (zipCode: string): boolean => {
    const firstTwoValuesOfZipCode = (zipCode || '').toString().slice(0, 2)

    /**
     * 10 -> Berlin city centre
     * 11 -> Federal Institutions in Berlin
     * 12 -> South and South-East Berlin
     * 13 -> North Berlin
     * 14 -> Potsdam and South-West Berlin, Rathenow, Luckenwalde, Brandenburg an der Havel
     */
    switch (firstTwoValuesOfZipCode) {
      case '10':
      case '11':
      case '12':
      case '13':
      case '14':
        return true
      default:
        return false
    }
  },

  berlinAndBrandenburg: (zipCode: string): boolean => {
    const firstTwoValuesOfZipCode = (zipCode || '').toString().slice(0, 2)

    switch (firstTwoValuesOfZipCode) {
      case '10':
      case '11':
      case '12':
      case '13':
      case '14':
      case '15':
      case '16':
        return true
      default:
        return false
    }
  },
}

export default isPostcodeFrom
